package ru.villawonka.app.data.entity.request

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import ru.villawonka.app.domain.model.CountryDomain
import ru.villawonka.app.domain.model.CurrencyDomain
import ru.villawonka.app.domain.model.LanguageDomain
import ru.villawonka.app.domain.model.UserSettingsDomain

@Serializable
data class UserSettingsRequest (
    @SerialName("country") val country: String?,
    @SerialName("currency") val currency: String?,
    @SerialName("language") val language: String?,
)

fun UserSettingsDomain.toRequest() = UserSettingsRequest(
    country = when (country) {
        CountryDomain.INDONESIA -> "ID"
        CountryDomain.THAILAND -> "TH"
        CountryDomain.VIETNAM -> "VN"
    },
    currency = when (currency) {
        CurrencyDomain.IDR -> "IDR"
        CurrencyDomain.USD -> "USD"
        CurrencyDomain.RUB -> "RUB"
        CurrencyDomain.CNY -> "CNY"
    },
    language = when (language) {
        LanguageDomain.EN -> "en"
        LanguageDomain.RU -> "ru"
    },
)